import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from "../../modules/shared.module";

// translation
import { TranslateModule } from '@ngx-translate/core';

import { SetPasswordPage } from './set-password.page';

const routes: Routes = [
  {
    path: '',
    component: SetPasswordPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild(),
    SharedModule
  ],
  declarations: [SetPasswordPage]
})
export class SetPasswordPageModule {}
